import * as React from 'react';
import * as classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SVG } from '../../Utils/SVG';
import { EVENT_HANDLED_NAV } from '../../../constants';
import { NavigationRoot } from '../../../models';
const edgeOfPlayIconURL = require('../../../icons/large-logo.svg');
const userIconURL = require('../../../icons/user.svg');
const searchIconURL = require('../../../icons/search.svg');
import DonateButton from '../../Common/DonateButton';
import './style.css';

export interface HeaderProps {
  navigationItems: Array<NavigationRoot>;
  onToggleNav: () => void;
}

export interface HeaderState {
  /* empty */
}

export class Header extends React.Component<HeaderProps, HeaderState> {
  render() {
    const { navigationItems } = this.props;

    return (
      <header className="header">
        <h1>
          <Link to="/">
            <SVG className="header-logo" src={edgeOfPlayIconURL} />
          </Link>
          <div className="header-tag-line">
            Hundreds of soccer coaching videos
          </div>
        </h1>
        <div className="header-buttons">
          <div className="desktop-buttons">
            <DonateButton
              key="header-donate"
              className="donate-form edge-of-play-link header-link"
            />
            {navigationItems &&
              navigationItems.map(navigationItem => (
                <Link
                  key={navigationItem.url}
                  className={classNames({
                    'edge-of-play-link': true,
                    'header-link': true,
                    'sign-up-link': navigationItem.url === '/sign-up',
                    'premium-content-link': navigationItem.url === '/premier'
                  })}
                  to={navigationItem.url}
                  onClick={navigationItem.onClick}
                >
                  {this.getNavigationItemIcon(navigationItem)}
                  {navigationItem.name}
                </Link>
              ))}
          </div>
          <div className="mobile-buttons">
            <button className="mobile-menu-toggle" onClick={this.toggleNav}>
              ≡
            </button>
          </div>
        </div>
      </header>
    );
  }

  private toggleNav = (event: React.MouseEvent<HTMLElement>) => {
    const { onToggleNav } = this.props;

    // Use persist to remove synthetic react event
    event.persist();

    // And flag the event as handled for navigation, so we don't insta-close
    // the nav when we're trying to open it
    event[EVENT_HANDLED_NAV] = true;

    onToggleNav();
  };

  private getNavigationItemIcon = (
    navigationItem: NavigationRoot
  ): JSX.Element | null => {
    switch (navigationItem.url) {
      case `/profile`:
        return (
          <SVG
            className="header-navigation-icon header-user-icon"
            src={userIconURL}
          />
        );
      case `/search`:
        return (
          <SVG
            className="header-navigation-icon header-search-icon"
            src={searchIconURL}
          />
        );
      default:
        return null;
    }
  };
}

export default Header;



// WEBPACK FOOTER //
// ./src/app/components/App/Header/index.tsx